import { isNullOrEmpty } from './search/facets/utils';
import Kendra from 'aws-sdk/clients/kendra';
import { AttributeMap, DocumentAttributeKeys } from './constants';

export function unionSortedHighlights(
    highlights: Kendra.HighlightList
): Kendra.HighlightList {
    if (isNullOrEmpty(highlights)) {
        return highlights;
    }

    let prev = highlights[0];
    const unioned = [prev];
    for (let i = 1; i < highlights.length; i++) {
        const h = highlights[i];
        if (prev.EndOffset >= h.BeginOffset) {
            // union
            prev.EndOffset = Math.max(h.EndOffset, prev.EndOffset);
            prev.TopAnswer = prev.TopAnswer || h.TopAnswer;
        } else {
            // disjoint, add to results
            unioned.push(h);
            prev = h;
        }
    }

    return unioned;
}

export const localizedDate = (
    date: Date,
    options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        month: 'short',
        timeZone: 'UTC',
        timeZoneName: 'short',
        year: 'numeric',
    }
): string => {
    return date ? date.toLocaleDateString('en', options) : '';
};

export const truncateString = (str: string, maxLen: number): string => {
    if (str.length <= maxLen) {
        return str;
    }

    if (maxLen < 5) {
        return `${str.substring(0, 3)}...`;
    }

    const charsToShow = maxLen - 3; // Account for the 3 dots
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);

    return `${str.substring(0, frontChars)}...${str.substring(
        str.length - backChars
    )}`;
};

export const selectMostRecentUpdatedTimestamp = (
    documentAttributes: AttributeMap
): Date | undefined => {
    const updatedAt = documentAttributes[DocumentAttributeKeys.UpdatedAt];
    const createdAt = documentAttributes[DocumentAttributeKeys.CreatedAt];

    if (updatedAt && updatedAt.StringValue) {
        return new Date(updatedAt.StringValue);
    } else if (updatedAt && updatedAt.DateValue) {
        return updatedAt.DateValue;
    } else if (createdAt && createdAt.StringValue) {
        return new Date(createdAt.StringValue);
    } else if (createdAt && createdAt.DateValue) {
        return createdAt.DateValue;
    } else {
        return undefined;
    }
};
